<template>
  <v-container
    class="login-page d-flex justify-content-center item-align-center"
    fill-height
    fluid
  >
    <v-card elevation="7" width="400px">
      <v-app-bar class="text-white pa-1" color="primary">
        <v-toolbar-title class="mx-auto">
          <strong><h1>S.T.A.R.S. Admin</h1></strong>
        </v-toolbar-title>
      </v-app-bar>

      <v-card-text>
        <v-form ref="login" v-model="valid" lazy-validation>
          <v-text-field
            v-model="email"
            outlined
            placeholder="E-posta"
            prepend-icon="mdi-account"
            required
            type="email"
            @keypress.enter="onSubmit"
          />

          <v-text-field
            v-model="password"
            :append-icon="password && password.length > 0 ? 'mdi-eye' : ''"
            :type="eye ? 'text' : 'password'"
            outlined
            placeholder="Parola"
            prepend-icon="mdi-lock"
            required
            @keypress.enter="onSubmit"
            @click:append="eye = !eye"
          />

          <v-card-actions class="d-flex justify-content-end mt-2">
            <v-btn
              :disabled="!valid"
              :loading="loading"
              color="primary"
              @click="onSubmit"
            >
              Giriş Yap
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import { ADMIN_LOGIN, DELETE_STATE } from "@/core/services/store/auth.module";

export default {
  name: "SM-Admin-Login",
  data() {
    return {
      email: null,
      password: null,
      eye: false,
      valid: true,
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      adminLogin: ADMIN_LOGIN,
      deleteState: DELETE_STATE,
      redirectAfterLogin: "redirectAfterLogin",
    }),
    async onSubmit() {
      const valid = this.$refs.login.validate();
      if (!valid) return;

      this.loading = true;
      await this.deleteState();

      try {
        await this.adminLogin({ email: this.email, password: this.password });
        // Admin login yaptıktan sonra yönlendirme
        window.localStorage.setItem("loginType", "admin");
        this.redirectAfterLogin();
      } catch (e) {
        await this.deleteState();
        this.$toast.error("E-Posta veya parola hatalı.", {
          position: "bottom-right",
          duration: 2000,
        });
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    password() {
      if (this.eye) this.eye = false;
    },
  },
};
</script>
